module.exports = __webpack_public_path__ + "img/foul.629fdaa2.png";